module.exports = __webpack_public_path__ + "static/media/xmark-solid.65ebf632.svg";